<template>
  <div class="header">
    <div class="title cl">
      <h1 class="fl">
        <a href="https://www.yilieyun.com" title="易猎云招聘管理系统">
        <img
          @click="gotohome"
          class="img100 homelogo"
          src="https://img.yilieyun.cn/tenant-logo/48/2023/companyLogo_1204112135.png"
          alt=""
        />
      </a>
      </h1>
      <ul class="nav fl">
        <router-link
          active-class="active"
          v-for="(item, index) in navData"
          :key="index"
          :to="{ path: item.path, query: routeData }"
          :class="{
            active_s: pathname.includes('/media') && item.name === '关于我们'
            ||pathname.includes('/coverage/1') && item.name === '关于我们'
            ||pathname.includes('/coverage/2') && item.name === '关于我们'
            ||pathname.includes('/coverage/3') && item.name === '关于我们'
            ||pathname.includes('/coverage/4') && item.name === '关于我们'
            ||pathname.includes('/coverage/5') && item.name === '关于我们'
            ||pathname.includes('/coverage/6') && item.name === '关于我们'
            ||pathname.includes('/coverage/7') && item.name === '关于我们'
            ||pathname.includes('/coverage/8') && item.name === '关于我们'
            ||pathtext=='/'&&item.name === '首页'
            ||pathtext=='/price'&&item.name === '价格'
            ||pathtext=='/learning'&&item.name === '学习中心'
            ||pathtext=='/product'&&item.name === '产品'
            ||pathtext=='/large'&&item.name === '产品'
            ||pathtext=='/mobile'&&item.name === '产品'
            ||pathtext=='/about'&&item.name === '关于我们'
            ||pathtext=='/media'&&item.name === '关于我们'

          }"
          style="position: relative;"
          :style="{width:item.name=='产品'?'80px':''}"
          @click.native="gotochild(item.path)"
          v-show="index<5"
        >
          <span @mouseenter="down_box(item.name)">{{ item.name }} </span>
          <span  @mouseenter="down_box(item.name)" v-show="item.name=='产品'" :class="visible==true ? 'dropshow':'drop_box'">
            <img v-show="index==1"   class="icon_down" src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/icon_down_al.png"/>
          </span>
            <div v-show="index==1&&visible" class="small_lx"></div>
        </router-link>
        <div  v-if="visible" @mouseenter="down_box()"  @mouseleave="down_box_close()" class="poper_box">
          <p @click.stop="todoproduct('1')">RPO招聘管理系统</p>
          <p @click.stop="todoproduct('2')">HR招聘管理系统</p>
          <p @click.stop="todoproduct('3')">外包管理系统</p>
          <p @click.stop="todoproduct('4')">企微助手</p>
          <p @click.stop="todoproduct('5')">渠道及发单平台</p>
          <p @click.stop="todoproduct('7')">易猎云工作手机</p>
          <p @click.stop="todoproduct('6')">易外呼APP</p>
        </div>
      </ul>
      <div class="hotline fr cl">
        <img
          src="https://img.yilieyun.com/oss/ylyofficialWebImagse/icon_telephone@2x.png"
        />
        <span class="tel">400-0588-036</span>
        <span class="ontrial" @click="trial" v-show="!name">免费开通</span>
        <span @click="showLoginType()" class="login" v-show="!name">登录</span>
        <span class="login_name" v-show="name" @click="todoats()">{{name&&name.length>5?name.substring(0,4):name}}</span>
        <span class="login_name2" @click="backout()" v-show="name">退出</span>
      </div>
    </div>
    <!--申请试用组件-->
    <populone :isshow="windowflags" :he="false" @handleChange="changewindows" />
    <login v-if="showLogin"></login>
    <div v-show="visible" @click="()=>visible=false" class="bigbox" ></div>
  </div>
</template>

<script>
import populone from "@/components/views/popul/populone";
import login from "@/components/views/login/index.vue";
import { boo } from "../../../tool/apiboo";

export default {
  data() {
    return {
      visible:false,
      windowflags: false,
      navData: [
        { name: "首页", path: "/" },
        { name: "产品", path: "/product" },
        //{ name: "产品", path: "/large" },
        { name: "价格", path: "/price" },
        { name: "学习中心", path: "/learning" },
        { name: "关于我们", path: "/about" },
        { name: "媒体报道", path:"/media"},
        { name: "1",path:"/coverage/1"},
        { name: "2",path:"/coverage/2"},
        { name: "3",path:"/coverage/3"},
        { name: "4",path:"/coverage/4"},
        { name: "5",path:"/coverage/5"},
        { name: "6",path:"/coverage/6"},
        { name: "7",path:"/coverage/7"},
        { name: "8",path:"/coverage/8"},
      ],
      pathname: window.location.pathname,
      showLogin: false,
      activePath: "",
      routeData: {},
      pathtext:'/',
      lastout:'',
      name:''
    };
  },
  components: {
    populone,
    login,
  },
  beforeCreate(){
   if(this.$route.query.type==1){
     sessionStorage.setItem('path','/price');
   }
  },
  mounted() {
    
   let pathstr= sessionStorage.getItem('path');
   this.type= this.$route.params.id;
   let learnobj=this.$route.query.learnobj;//标准版学习中心
   let mobileobject=this.$route.query.mobileobject;//标准版工作手机
   if(this.type==2){//平台产品-详情跳转过来
    console.log("zzzzzzzzz");
      this.pathtext='/large'
      this.$router.push({
        path: "/large/2",
      //  query: this.routeData,
      });
   }else if(this.type=='hr'){
    this.pathtext='/product'
      this.$router.push({
        path: "/product/hr",
      //  query: this.routeData,
      });

   }else if(!!mobileobject){
     this.pathtext='/product'
     let mobileobj=JSON.parse(mobileobject);
      //console.log(mobileobject,'拿参数--');
      let {name,versionsStatus,domain}=mobileobj.profile;
      let {access_token,playedu_token}=mobileobj;
      localStorage.setItem('name',name);
      localStorage.setItem('versionsStatus',versionsStatus);
      localStorage.setItem('access_token',access_token);
      localStorage.setItem('playedu_token',playedu_token);
      localStorage.setItem('domanUrl',domain);
      localStorage.setItem('userinfo',JSON.stringify(mobileobj));
     this.$router.push({
        path: "/products/mobile",
      //  query: this.routeData,
      });
   }else if(!!learnobj){

    let learn=JSON.parse(learnobj);
    //console.log(learn,'拿参数');
    let {name,versionsStatus,domain}=learn.profile;
    let {access_token,playedu_token}=learn;
    localStorage.setItem('name',name);
    localStorage.setItem('versionsStatus',versionsStatus);
    localStorage.setItem('access_token',access_token);
    localStorage.setItem('playedu_token',playedu_token);
    localStorage.setItem('domanUrl',domain);
    localStorage.setItem('userinfo',JSON.stringify(learn));
    // const userinfo2= {
    //             "access_token": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhdWQiOiJhcGkiLCJpc3MiOiJ5aWxpZSIsInRlbmFudElkIjoiMSIsInVzZXJJZCI6IjE1MzAiLCJuYW1lIjoi56uL5rOJIiwibW9iaWxlIjoiMTc2MDE2Mzg0MzAiLCJ1c2VyQ3JlYXRlRGF0ZSI6IjA0LzE3LzIwMjMgMTA6MzM6MjYiLCJhdXRoVGltZSI6IjE3MjQyOTIwNTciLCJwcm9qZWN0SWQiOiIiLCJwb3J0YWxJZCI6IjAiLCJ1c2VyVHlwZSI6IjAiLCJuYmYiOjE3MjQyOTIwNTcsImV4cCI6MTcyNTUwMTY1NywiaWF0IjoxNzI0MjkyMDU3fQ.dXmpm9BbsYFJ98DFCrWRJquTxL8OWqYSZXcjQ9KQSuw",
    //             "playedu_token": "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJsb2dpblR5cGUiOiJsb2dpbiIsImxvZ2luSWQiOjMwLCJyblN0ciI6ImdHODlNYWZya1M3b2lXZ2dzblpkakFWNFlWaG5qOE01IiwidXJsIjoiaHR0cDovL3BsYXllZHVhcGkueWlsaWV5dW4uY24vYXBpL3YxL2F1dGgvbG9naW4vcGFzc3dvcmQiLCJwcnYiOiI4ZjliZmU5ZDEzNDUyMzdjYjNiMmIyMDU4NjRkYTA3NSIsImV4cCI6IjE3MjU1ODgwNTc3MjIifQ.zBSD6D2lBL8ABzl89ysVQO8IUcs6JLlMvt4MJK8_u0s",
    //             "token_type": "Bearer",
    //             "profile": {
    //                 "role": 0,
    //                 "tenantId": 1,
    //                 "userId": 1530,
    //                 "name": "立泉",
    //                 "domain": "ats-dev.yilieyun.cn",
    //                 "tenantName": "易猎云（海南）科技公司",
    //                 "mobile": "17601638430",
    //                 "createDate": "2023-04-17",
    //                 "auth_time": 1724292057,
    //                 "expires_at": 1725501657,
    //                 "passwordStatus": 1,
    //                 "clientClassify": "业务不匹配",
    //                 "versionsStatus": 5
    //             }
    //         };
    //       localStorage.setItem('name',"立泉");
    //       localStorage.setItem('versionsStatus',5);
    //       localStorage.setItem('access_token','eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhdWQiOiJhcGkiLCJpc3MiOiJ5aWxpZSIsInRlbmFudElkIjoiMSIsInVzZXJJZCI6IjE1MzAiLCJuYW1lIjoi56uL5rOJIiwibW9iaWxlIjoiMTc2MDE2Mzg0MzAiLCJ1c2VyQ3JlYXRlRGF0ZSI6IjA0LzE3LzIwMjMgMTA6MzM6MjYiLCJhdXRoVGltZSI6IjE3MjQyOTIwNTciLCJwcm9qZWN0SWQiOiIiLCJwb3J0YWxJZCI6IjAiLCJ1c2VyVHlwZSI6IjAiLCJuYmYiOjE3MjQyOTIwNTcsImV4cCI6MTcyNTUwMTY1NywiaWF0IjoxNzI0MjkyMDU3fQ.dXmpm9BbsYFJ98DFCrWRJquTxL8OWqYSZXcjQ9KQSuw');
    //       localStorage.setItem('playedu_token','eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJsb2dpblR5cGUiOiJsb2dpbiIsImxvZ2luSWQiOjMwLCJyblN0ciI6ImdHODlNYWZya1M3b2lXZ2dzblpkakFWNFlWaG5qOE01IiwidXJsIjoiaHR0cDovL3BsYXllZHVhcGkueWlsaWV5dW4uY24vYXBpL3YxL2F1dGgvbG9naW4vcGFzc3dvcmQiLCJwcnYiOiI4ZjliZmU5ZDEzNDUyMzdjYjNiMmIyMDU4NjRkYTA3NSIsImV4cCI6IjE3MjU1ODgwNTc3MjIifQ.zBSD6D2lBL8ABzl89ysVQO8IUcs6JLlMvt4MJK8_u0s');
    //       localStorage.setItem('domanUrl','ats-dev.yilieyun.cn');
    //       localStorage.setItem('userinfo',JSON.stringify(userinfo2));
          this.pathtext='/learning'
    
   } else{
    if(pathstr!=null){
    if(pathstr=='/'){
      this.pathtext='/'
      this.$router.push({
        path: "/",
        query: this.routeData,
      });
    }else if(pathstr=='/product'){
      this.pathtext='/product'
      this.$router.push({
        path: "/product",
        query: this.routeData,
      });
    }else if(pathstr=='/price'){
      this.pathtext='/price'
      this.$router.push({
        path: "/price",
        query: this.routeData,
      });
    }else if(pathstr=='/learning'){
      console.log('上帝双氯芬酸');
      this.pathtext='/learning'
      this.$router.push({
        name: "Learining",
        query: this.routeData,
      });
    }else if(pathstr=='/about'){
       this.pathtext='/about'
      // this.$router.push({
      //   path: "/about",
      //   query: this.routeData,
      // });
    }else if(pathstr=='/media'){
      this.pathtext='/media'
      // this.$router.push({
      //   path: "/media",
      //   query: this.routeData,
      // });
    }
   }
   }

   //console.log(this.pathtext,'###@@@');

    // if(this.type==1){
    //   this.navData.splice(2,1)
    // }else if(this.type==2){
    //   this.navData.splice(1,1)
    // }else{
    //   console.log('没有值的时候');
    //   this.navData.splice(2,1)
    // }

    let utm_source = "";
    let utm_content = "";
    let u = "";
    const url = `https://officialsiteapi${boo()}.yilieyun.com/siteapi/Apply/officialUrlClickNum`;
    let query = this.$route.query;
    if (Object.keys(query).length) {
      utm_source = query.utm_source;
      utm_content = query.utm_content;
      u = query.u;
      let params = new FormData();
      params.append("utm_source", utm_source);
      params.append("utm_content", utm_content);
      params.append("u", u);
      this.$axios({
        url,
        method: "post",
        data: params,
      });
      console.log("sssssssssssssssssss");
    }
    if (Object.keys(this.$route.query).length) {
      this.routeData = this.$route.query;
    }
    // const { u2 = "" } = this.routeData;
    // if (!u2) {
    //   console.log("WWWW");
    //   zhuge.track("官网加载", {
    //     渠道: "移动",
    //     utm类型: "自然流量",
    //   });
    // } else {
    //   zhuge.track("官网加载", {
    //     渠道: "移动",
    //     utm类型: "驱动流量",
    //   });
    // }
    this.name=localStorage.getItem('name')||'';
    this.$eventBus.$on("loginModel", (param) => {
      this.showLogin = param;
      this.name=localStorage.getItem('name');
    });
    setInterval(()=>{
      this.name=localStorage.getItem('name');
    },2000)
  },
  watch: {
    immediate:true,
        deep: true,
        $route(to, from){
          localStorage.setItem('supertype','1');
            // console.log('路由变化了')
             console.log('当前页面路由：' + to.name);
             if(to.path=='/'){
              this.pathtext='/'
              sessionStorage.setItem('path','/');
             }else if(to.path=='/price'){
              this.pathtext='/price'
              sessionStorage.setItem('path','/price');
             }else if(to.name=='Learining'){
              console.log('上帝双氯芬酸22');
              this.pathtext='/learning'
              sessionStorage.setItem('path','/learning');
             }else if(to.path=='/product'){
              this.pathtext='/product'
              sessionStorage.setItem('path','/product');
             }else if(to.path=='/about'){
              this.pathtext='/about'
              sessionStorage.setItem('path','/about');
             }else if(to.path=='/large/2'){
              console.log('路由监听',to.path);
              this.pathtext='/large'
              sessionStorage.setItem('path','/large');
             }else if(to.path=='product'){
              this.pathtext='/product'
              sessionStorage.setItem('path','/product');
             }else if(to.path=='/media'){
              this.pathtext='/media'
              sessionStorage.setItem('path','/media');
             }else if(to.path=='/product/hr'){
              this.pathtext='/product'
             }else if(to.path=='/products/mobile'){
              this.pathtext='/product'
             }else if(to.path=='/product/outsource'){
              this.pathtext='/product'
             }else if(to.path=='/product/wecom'){
              this.pathtext='/product'
             }else if(to.path=='/product/ordering'){
               this.pathtext='/product'
             }else if(to.path=='/product/ecall'){
               this.pathtext='/product'
             }
             console.log(this.pathtext,'看看');
            // console.log('上一个路由：' + from);
            this. navData= [
                { name: "首页", path: "/" },
                { name: "产品", path: "/product" },
                { name: "价格", path: "/price" },
                { name: "学习中心", path: "/learning" },
                { name: "关于我们", path: "/about" },
                { name: "媒体报道", path:"/media"},
                { name: "1",path:"/coverage/1"},
                { name: "2",path:"/coverage/2"},
                { name: "3",path:"/coverage/3"},
                { name: "4",path:"/coverage/4"},
                { name: "5",path:"/coverage/5"},
                { name: "6",path:"/coverage/6"},
                { name: "7",path:"/coverage/7"},
                { name: "8",path:"/coverage/8"},
              ]
        },

    },
  methods: {
    gotohome() {
      this.$router.push({
        path: "/",
        query: this.routeData,
      });

      if (this.activePath !== "/about") this.pathname = "";
      document.documentElement.scrollTop = 0;
    },
    gotochild(path) {
      this.pathname=window.location.pathname;
      this.activePath = path;
      if (path !== "/about") this.pathname = "";
      document.documentElement.scrollTop = 0;
    },
    trial() {
      this.windowflags = true;
    },
    changewindows(value) {
      this.windowflags = value;
    },
    showLoginType() {
      this.showLogin = true;
      localStorage.setItem('learntype','2');
    },
    down_box(name){
      if(name=='产品'){
        this.visible=true;
      }
    },
    down_box_close(){
      console.log("离开了");
      clearInterval(this.lastout);
      this.lastout= setTimeout(() => {
        this.visible=false;
      }, 300);
    
    },
    todoproduct(val){
      if(val=='1'){
        this.pathtext='/product'
        this.visible=false;
        this.$router.push({
          path: "/product",
        });
      }else if(val=='2'){
        this.pathtext='/product'
        this.visible=false;
        this.$router.push({
          path: "/product/hr",
        });
      }else if(val=='3'){
        this.pathtext='/product'
        this.visible=false;
        this.$router.push({
          name: "Productoutsource",
        });
      }else if(val=='4'){
        this.pathtext='/product'
        this.visible=false;
        this.$router.push({
          name: "Productwecom",
        });
      }else if(val=='5'){
        this.pathtext='/product'
        this.visible=false;
        this.$router.push({
          name: "Productordering",
        });
      }else if(val=='6'){
        this.pathtext='/product'
        this.visible=false;
        this.$router.push({
          name: "Productecall",
        });
      }else if(val=='7'){
        this.pathtext='/product'
        this.visible=false;
        this.$router.push({
          path: "/products/mobile",
        });
      }

    },
    backout(){
      localStorage.removeItem("name");
      localStorage.removeItem("versionsStatus");
      localStorage.removeItem("access_token");
      localStorage.removeItem("playedu_token");
      localStorage.removeItem("domanUrl");
      localStorage.removeItem("userinfo");
      localStorage.removeItem("ClientBrowseIds");
    },
    todoats(){
     let domanUrl= localStorage.getItem('domanUrl');
     let userinfo= localStorage.getItem('userinfo');
     var cbid= localStorage.getItem("ClientBrowseIds", "");
     let newuser=JSON.parse(userinfo);
     newuser.ClientBrowseId=cbid;
     let {playedu_token, ...newObj} = newuser;
     console.log( "https://" + domanUrl + "#/jump/?userinfo=" + JSON.stringify(newObj));
     window.open(
            "https://" + domanUrl + "#/jump/?userinfo=" + JSON.stringify(newObj)
          );
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@import "~@/assets/css/style/index.less";
@import "~@/assets/css/style/config.less";

.header {
  width: 100%;
  min-width: 100vw;
  height: 85px;
  position: fixed;
  top: 0px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 20;
  background: #ffffff;
  border-bottom: solid 2px #e4ecff;

  .title {
    padding-top: 14px;
    width: 1490px;
    height: 105px;
    margin: 0 auto;
    font-size: 20px;
    // background:red;
    h1 {
      width: 199px;
      height: 54px;
    }

    .homelogo {
      cursor: pointer;
    }

    .nav {
      position: relative;
      padding-top: 13px;
      width: 770px;
      height: 68px;
      margin-left: 68px;

      a {
        cursor: pointer;
        display: inline-block;
        margin-right: 78px;
        font-size: 24px;
        font-weight: 600;
        color: #405374;
      }

      a:last-child {
        margin-right: 0;
      }
    }

    .hotline {
      position: relative;
      width: 432px;
      height: 81px;
      padding-left: 0;

      img {
        position: absolute;
        display: inline-block;
        width: 27px;
        height: 30px;
        top: 12px;
      }

      .tel {
        display: inline-block;
        height: 30px;
        color: #405374;
        font-size: 22px;
        margin-left: 38px;
        margin-top: 17px;
      }

      .ontrial {
        position: absolute;
        display: inline-block;
        width: 114px;
        height: 50px;
        background: #fb983c;
        border-radius: 7px;
        color: #ffffff;
        font-size: 18px;
        text-align: center;
        line-height: 50px;
        cursor: pointer;
        right: 110px;
      }

      .login {
        float: right;
        cursor: pointer;
        width: 95px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        background: #deefff;
        border-radius: 7px;
        border: 1px solid #0084ff;
        color: #0084ff;
      }
      .login_name{
        display: inline-block;
        cursor: pointer;
        width: 105px;
        height: 50px;
        line-height: 50px;
        text-align: right;
        margin-left: 20px;
       
      }
      .login_name2{
        display: inline-block;
        cursor: pointer;
        width: 85px;
        height: 50px;
        line-height: 50px;
        text-align: left;
        color: #0084ff;
        margin-left: 10px;
      }
    }
  }
}

.active_s_s {
}

.active {

}

.active_s {
  padding-bottom: 32px;
  border-bottom: solid 4px #0084ff;
  color: #0084ff;
}
.icon_down{
 
}
.poper_box{
  position: absolute;
  min-width: 203px;
  background-color: #ffffff;
  border-radius: 12px;
  top: 60px;
  left: 115px;
  box-shadow: -1px 2px 15px 0px #E2EDFF;
  padding: 20px 0px;
  z-index: 1000;
  p{
    font-size: 18px;
    height: 40px;
    line-height: 40px;
    padding-left: 30px;
    box-sizing: border-box;
    cursor: pointer;
  }
  p:hover{
    color: #0084ff;
    background: #DCEEFF;
  }
}
.small_lx{
  position: absolute;
  width: 0;
  height: 0;
  left: 64px;
  top: 33px;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 10px solid #ffffff;
 
}
.bigbox{
  position: fixed;
  left: 0;
  top: 50px;
  right: 0;
  bottom: -1000px;
  z-index: 999;
}
.drop_box{
  display:inline-block; 
  width: 40px;
  height: 100px;
  position: absolute;
  left: 60px;
}
.dropshow{
  display:inline-block; 
  width: 140px;
  height: 280px;
  position: absolute;
  left: 60px;
}
</style>





// WEBPACK FOOTER //
// src/components/views/header/index.vue